import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "upper-header padding-h-standard" }
const _hoisted_2 = { "data-testing": "page-header" }
const _hoisted_3 = {
  class: "btn-3 right-icon",
  type: "button"
}

import { mdiLogout, mdiAccount } from "@mdi/js";

import { useUIGeneralStore } from "@/stores/ui-general.store";
import { useUsersStore } from "@/stores/users.store";

import { useLogout } from "@/composables/use-logout";


export default /*#__PURE__*/_defineComponent({
  __name: 'UpperHeader',
  setup(__props) {

const uiGeneralStore = useUIGeneralStore();
const usersStore = useUsersStore();
const { logout } = useLogout();

return (_ctx: any,_cache: any) => {
  const _component_SVGIcon = _resolveComponent("SVGIcon")!
  const _component_b_dropdown_item = _resolveComponent("b-dropdown-item")!
  const _component_b_dropdown = _resolveComponent("b-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(uiGeneralStore).pageHeading), 1),
    _createVNode(_component_b_dropdown, {
      class: "is-block",
      "aria-role": "menu",
      position: "is-bottom-left",
      hoverable: "",
      "mobile-modal": false,
      "data-testing": "account-dropdown"
    }, {
      trigger: _withCtx(() => [
        _createElementVNode("button", _hoisted_3, [
          _createVNode(_component_SVGIcon, {
            path: _unref(mdiAccount),
            size: 36
          }, null, 8, ["path"])
        ])
      ]),
      default: _withCtx(() => [
        (_unref(usersStore).currentUser)
          ? (_openBlock(), _createBlock(_component_b_dropdown_item, {
              key: 0,
              "aria-role": "menu-item",
              focusable: false,
              custom: true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_SVGIcon, {
                  path: _unref(mdiAccount),
                  class: "margin-r-half"
                }, null, 8, ["path"]),
                _createTextVNode(" " + _toDisplayString(_unref(usersStore).currentUser.displayName), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_b_dropdown_item, {
          "aria-role": "menu-item",
          focusable: false,
          custom: true
        }, {
          default: _withCtx(() => [
            _createElementVNode("button", {
              "data-testing": "logout-button",
              class: "btn-3",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(logout)()))
            }, [
              _createVNode(_component_SVGIcon, {
                path: _unref(mdiLogout),
                class: "margin-r-half"
              }, null, 8, ["path"]),
              _cache[1] || (_cache[1] = _createTextVNode(" Log out "))
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})